<template>
    <!-- Page Content -->
    <div class="d-lg-flex half">
        <div class="bg order-1 order-md-2"></div>
        <div class="contents order-2 order-md-1">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 py-4">
                        <div class="text-center mb-4">
                            <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand logo mr-0">
                                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                            </a>
                        </div>
                        <h3>Réinitialiser votre mot de passe</h3>
                        <!-- <p class="mb-4">Enter your email to get a password reset link</p> -->
                        <form @submit.prevent="resetPassword">
                            <div class="form-group card-label mb-3">
                                <label>Nouveau mot de passe</label>
                                <input 
                                    type="password" 
                                    class="form-control"
                                    :class="{ 'is-invalid': fieldErrors.new_password }"
                                    v-model="newPassword" 
                                    @input="updatePasswordStrength"
                                    required/>
                                <small class="text-muted d-block">Minimum 8 caractères avec majuscules, minuscules, chiffres et caractères spéciaux</small>
                                <small class="text-danger d-block" v-if="fieldErrors.new_password">{{ fieldErrors.new_password }}</small>
                                
                                <div class="mt-2" v-if="newPassword && !fieldErrors.new_password">
                                    <div class="progress" style="height: 5px;">
                                        <div class="progress-bar" :class="passwordStrengthClass" role="progressbar" 
                                            :style="{ width: passwordStrength + '%' }" :aria-valuenow="passwordStrength" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <small :class="passwordStrengthTextClass">{{ passwordStrengthText }}</small>
                                </div>

                                <ul class="list-unstyled mt-2" v-if="newPassword && !fieldErrors.new_password">
                                    <li :class="passwordRequirements.length ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.length ? 'check_circle' : 'cancel' }}</i>
                                        Minimum 8 caractères
                                    </li>
                                    <li :class="passwordRequirements.uppercase ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.uppercase ? 'check_circle' : 'cancel' }}</i>
                                        Au moins une majuscule
                                    </li>
                                    <li :class="passwordRequirements.lowercase ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.lowercase ? 'check_circle' : 'cancel' }}</i>
                                        Au moins une minuscule
                                    </li>
                                    <li :class="passwordRequirements.number ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.number ? 'check_circle' : 'cancel' }}</i>
                                        Au moins un chiffre
                                    </li>
                                    <li :class="passwordRequirements.special ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.special ? 'check_circle' : 'cancel' }}</i>
                                        Au moins un caractère spécial (@, #, $, !,...)
                                    </li>
                                </ul>
                            </div>

                            <div class="form-group card-label mb-3">
                                <label>Confirmer le nouveau mot de passe</label>
                                <input 
                                    type="password" 
                                    class="form-control"
                                    :class="{ 'is-invalid': fieldErrors.confirm_password }"
                                    v-model="confirmPassword"
                                    @input="fieldErrors.confirm_password = ''"
                                    required/>
                                <small v-if="confirmPassword && newPassword !== confirmPassword && !fieldErrors.confirm_password" class="text-danger d-block">
                                    Les mots de passe ne correspondent pas
                                </small>
                                <small class="text-danger d-block" v-if="fieldErrors.confirm_password">{{ fieldErrors.confirm_password }}</small>
                            </div>

                            <div v-if="linkError" class="alert alert-danger">
                                Le lien a expiré. Réinitialisez de nouveau !
                            </div>
                            <div class="submit-section">
                                <button type="submit" class="btn btn-primary btn-block btn-lg login-btn btn-rounded w-100" :disabled="!isFormValid()">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Réinitialisez Mot de Passe</label>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Page Content -->
</template>
<script>
import { api } from "@/store"; // Import axios from your store

export default {
    computed: {
        token() {
            return this.$route.query.token; // Access query parameter 'token'
        },
        passwordStrengthText() {
            if (this.passwordStrength < 20) return 'Très faible';
            if (this.passwordStrength < 40) return 'Faible';
            if (this.passwordStrength < 60) return 'Moyen';
            if (this.passwordStrength < 80) return 'Bon';
            return 'Très fort';
        },
        passwordStrengthClass() {
            if (this.passwordStrength < 20) return 'bg-danger';
            if (this.passwordStrength < 40) return 'bg-warning';
            if (this.passwordStrength < 60) return 'bg-info';
            if (this.passwordStrength < 80) return 'bg-success';
            return 'bg-success';
        },
        passwordStrengthTextClass() {
            if (this.passwordStrength < 20) return 'text-danger';
            if (this.passwordStrength < 40) return 'text-warning';
            if (this.passwordStrength < 60) return 'text-info';
            if (this.passwordStrength < 80) return 'text-success';
            return 'text-success';
        },
    },
    data() {
        return {
            newPassword: "",
            confirmPassword: "",
            passwordRequirements: {
                length: false,
                uppercase: false,
                lowercase: false,
                number: false,
                special: false,
            },
            passwordStrength: 0,
            fieldErrors: {
                new_password: '',
                confirm_password: '',
            },
            linkError: false,
        };
    },
    mounted() {
        // Content div min height set
        function resizeInnerDiv() {
            var height = $(window).height();
            var header_height = $(".header").height();
            var footer_height = $(".footer").height();
            var breadcrumb_height = $(".breadcrumb-bar").height();
            var setheight = height - breadcrumb_height - header_height;
            var trueheight = setheight - footer_height;
            $(".content").css("min-height", trueheight - 30);
        }

        if ($(".content").length > 0) {
            resizeInnerDiv();
        }

        $(window).resize(function () {
            if ($(".content").length > 0) {
                resizeInnerDiv();
            }
        });
    },
    methods: {
        updatePasswordStrength() {
            const password = this.newPassword;
            this.fieldErrors.new_password = ''; // Clear error when user types
            
            this.passwordRequirements.length = password.length >= 8;
            this.passwordRequirements.uppercase = /[A-Z]/.test(password);
            this.passwordRequirements.lowercase = /[a-z]/.test(password);
            this.passwordRequirements.number = /[0-9]/.test(password);
            this.passwordRequirements.special = /[@#$!%*?&^()_+=\-\[\]{};':"\\|,.<>\/?]/.test(password);

            let strength = 0;
            if (this.passwordRequirements.length) strength += 20;
            if (this.passwordRequirements.uppercase) strength += 20;
            if (this.passwordRequirements.lowercase) strength += 20;
            if (this.passwordRequirements.number) strength += 20;
            if (this.passwordRequirements.special) strength += 20;

            this.passwordStrength = strength;
        },
        isFormValid() {
            return (
                this.newPassword &&
                this.confirmPassword &&
                this.newPassword === this.confirmPassword &&
                this.passwordStrength === 100 &&
                !this.fieldErrors.new_password &&
                !this.fieldErrors.confirm_password
            );
        },
        async resetPassword() {
            this.fieldErrors = {
                new_password: '',
                confirm_password: '',
            };

            if (!this.newPassword) {
                this.fieldErrors.new_password = 'Le nouveau mot de passe est requis.';
                return;
            }
            if (!this.confirmPassword) {
                this.fieldErrors.confirm_password = 'La confirmation du mot de passe est requise.';
                return;
            }
            if (this.newPassword !== this.confirmPassword) {
                this.fieldErrors.confirm_password = 'Les mots de passe ne correspondent pas.';
                return;
            }
            if (this.passwordStrength !== 100) {
                this.fieldErrors.new_password = 'Le mot de passe ne respecte pas tous les critères de sécurité.';
                return;
            }

            let token = this.token; // Extract token from the URL query
            let payload = {
                password: this.newPassword,
                token: token,
            };

            const button = document.querySelector('.submit-section button[type="submit"]');
            const spinner = button.querySelector('.spinner-border');
            button.setAttribute('disabled', 'disabled');
            spinner.classList.remove('d-none');

            // Make request to FastAPI backend with JSON payload
            api.post("/auth/reset-password", payload, {
                headers: {
                    accept: "application/json", // Define accepted response format
                    "Content-Type": "application/json", // Content type is JSON
                },
            }).then(response => {
                // Handle the response if needed
                // You can add a redirect or success notification here if needed
                console.log(response.data);
                this.$router.push({ name: "login" });
            }).catch(error => {
                if (error.response && error.response.status === 400) {
                    this.linkError = true;
                }
            }).finally(() => {
                button.removeAttribute('disabled');
                spinner.classList.add('d-none');
            });
        },
    },
};
</script>

<style scoped>
.list-unstyled li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
}

.list-unstyled i {
    min-width: 20px;
}
</style>
